import { Component, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { ToastController } from '@ionic/angular';
import { Subject, takeUntil } from 'rxjs';
import { IMAGES_PATH } from 'src/app/enums & constants/paths.constants';
import { Post } from 'src/app/models/post';
import { User } from 'src/app/models/user';
import { VisitLike } from 'src/app/models/visit';
import { AuthService } from 'src/app/services/auth.service';
import { LinkManagerService } from 'src/app/services/link-manager.service';
import { MiradoresService } from 'src/app/services/miradores.service';
import { PushNotificationService } from 'src/app/services/push-notification.service';
import { VisitLikesManagerService } from 'src/app/services/visitLike-manager.service';

@Component({
  selector: 'app-new-visit',
  templateUrl: './new-visit.component.html',
  styleUrls: ['./new-visit.component.scss'],
})
export class NewVisitComponent implements OnInit, OnDestroy {

  @Input() post: Post;
  @Output() onViewPhoto: EventEmitter<string> = new EventEmitter();

  alreadyLiked: boolean = false;
  foundLikeId: string = null;
  currentSesion: User;
  currentUserVisitLikes: VisitLike[] = [];
  imageLoaded = false;

  avoidSessionInteractionButtonsClicks: boolean = false;
  loading: boolean = false;
  private unsubscribe$ = new Subject<void>();

  constructor(public auth: AuthService,
    private router: Router,
    private MIService: MiradoresService,
    private toastController: ToastController,
    private visitLikeService: VisitLikesManagerService,
    private pushNotificationService: PushNotificationService,
    private linkManager: LinkManagerService) { }

  ngOnInit() {
    this.getSession();
    this.post.countLikes = this.post.countLikes ? this.post.countLikes : 0;
  }

  onImageLoad() {
    this.imageLoaded = true;
  }

  getUrlCover(cover) {
    return !cover.toLowerCase().startsWith("https://") ? `${IMAGES_PATH}miradores/${cover}` : cover;
  }

 

  getSession() {
    this.auth.$establishedSession
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe(user => {
      this.currentSesion = user;
      if (user) {
        this.loading = true;

        this.auth.$myVisitLikes
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe((visits) => {
          if (visits.length) {
            let foundLike = visits.find((visitLike) => {
              return visitLike.visitId == this.post.visitId;
            });

            if (foundLike) {
              this.alreadyLiked = true;
              this.foundLikeId = foundLike.likeId;
            }
          }

          this.loading = false;

        });
      }

    })
  }

  generateAndOpenDinamikLink(path) {
    const dinamikLink = this.linkManager.generateDinamicLink(path);
    window.open(dinamikLink, '_self')
  }

  GoToElseProfile(user) {
    if (this.linkManager.isMobileWeb()) {
      this.generateAndOpenDinamikLink('else-profile/' + user.uid);
    } else {
      if (this.currentSesion && user.uid === this.currentSesion.uid) {
        this.router.navigate(['app/profile']);
      } else {
        this.router.navigate(['else-profile', user.uid]);
      }
    }
  }

  seeDetail(mirador) {
    const miradorNameNormalize = this.MIService.getNormalizedMiradorNameForURL(mirador.name);
    if (this.linkManager.isMobileWeb()) {
      this.generateAndOpenDinamikLink('mirador/' + miradorNameNormalize);
    } else {
      this.router.navigate([
        '/mirador',
        this.MIService.getNormalizedMiradorNameForURL(mirador.name),
      ]);
    }
  }

  openViewer(photo) {
    this.onViewPhoto.emit(photo);
  }

  async checkLikeVisit() {
    if (this.currentSesion) {
      if (!this.avoidSessionInteractionButtonsClicks) {
        this.avoidSessionInteractionButtonsClicks = true;
        if (this.alreadyLiked) {
          this.unlikeVisit();
        } else {
          this.likeVisit()
        }
      }
    } else {

      const toast = await this.toastController.create({
        message: 'Debes haber iniciado sesión para realizar esta acción',
        duration: 3000,
        position: 'bottom',
        buttons: [
          {
            text: 'Iniciar Sesión',
            role: 'info',
            handler: () => { this.router.navigate(['/login']) }
          }
        ]
      });

      await toast.present();
    }
  }

  likeVisit() {
    this.visitLikeService.SetLikedData(this.currentSesion, this.post.visit.visitId);
    let susc = this.visitLikeService.$isVisitLikeProcessDone
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe((likeId) => {
      if (likeId) {
        this.alreadyLiked = true;
        this.foundLikeId = likeId;
        this.avoidSessionInteractionButtonsClicks = false;
        this.pushNotificationService.sendLikeVisitPushNotification(this.currentSesion, this.post.userId)
        susc.unsubscribe();
      }
    })
  }

  unlikeVisit() {


    this.visitLikeService.removeLike(this.foundLikeId, this.post.visitId);
    let susc = this.visitLikeService.$isVisitLikeProcessDone
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe((isDone) => {
      if (isDone) {
        this.alreadyLiked = false;
        this.foundLikeId = null;
        this.avoidSessionInteractionButtonsClicks = false;
        susc.unsubscribe();
      }
    })
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

}
